"use strict";

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var cov_1k2pmu8boi = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/ApplicationBar.js";
  var hash = "460dba03e6eaf87f57fadfb4f42479c18fb77bb4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/ApplicationBar.js",
    statementMap: {
      "0": {
        start: {
          line: 32,
          column: 30
        },
        end: {
          line: 32,
          column: 57
        }
      },
      "1": {
        start: {
          line: 33,
          column: 28
        },
        end: {
          line: 33,
          column: 51
        }
      },
      "2": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "3": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 50
        }
      },
      "4": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 66
        }
      },
      "5": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 42,
          column: 3
        }
      },
      "6": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 13
        }
      },
      "7": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 51,
          column: 6
        }
      },
      "8": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 59,
          column: 6
        }
      },
      "9": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 66,
          column: 6
        }
      },
      "10": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 91,
          column: 4
        }
      },
      "11": {
        start: {
          line: 94,
          column: 0
        },
        end: {
          line: 103,
          column: 2
        }
      },
      "12": {
        start: {
          line: 105,
          column: 30
        },
        end: {
          line: 105,
          column: 94
        }
      }
    },
    fnMap: {
      "0": {
        name: "ApplicationBarComponent",
        decl: {
          start: {
            line: 18,
            column: 9
          },
          end: {
            line: 18,
            column: 32
          }
        },
        loc: {
          start: {
            line: 31,
            column: 3
          },
          end: {
            line: 92,
            column: 1
          }
        },
        line: 31
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }, {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }],
        line: 35
      },
      "1": {
        loc: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 20
          }
        }, {
          start: {
            line: 35,
            column: 24
          },
          end: {
            line: 35,
            column: 45
          }
        }],
        line: 35
      },
      "2": {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        }, {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        }],
        line: 40
      },
      "3": {
        loc: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 17
          }
        }, {
          start: {
            line: 40,
            column: 21
          },
          end: {
            line: 40,
            column: 25
          }
        }],
        line: 40
      },
      "4": {
        loc: {
          start: {
            line: 82,
            column: 13
          },
          end: {
            line: 82,
            column: 38
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 82,
            column: 20
          },
          end: {
            line: 82,
            column: 33
          }
        }, {
          start: {
            line: 82,
            column: 36
          },
          end: {
            line: 82,
            column: 38
          }
        }],
        line: 82
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "460dba03e6eaf87f57fadfb4f42479c18fb77bb4"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplicationBar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

require("@material-ui/icons");

var _styles2 = _interopRequireDefault(require("./styles"));

var _ = require("./");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ApplicationBarComponent(_ref) {
  var classes = _ref.classes,
      title = _ref.title,
      buttons = _ref.buttons,
      drawerMenu = _ref.drawerMenu,
      authentication = _ref.authentication,
      onAuthentication = _ref.onAuthentication,
      authenticationConfig = _ref.authenticationConfig,
      repository = _ref.repository,
      onRepository = _ref.onRepository,
      repositoryConfig = _ref.repositoryConfig,
      blob = _ref.blob,
      onBlob = _ref.onBlob;
  cov_1k2pmu8boi.f[0]++;

  var _authenticationConfig = (cov_1k2pmu8boi.s[0]++, _objectSpread({}, authenticationConfig));

  var _repositoryConfig = (cov_1k2pmu8boi.s[1]++, _objectSpread({}, repositoryConfig));

  cov_1k2pmu8boi.s[2]++;

  if ((cov_1k2pmu8boi.b[1][0]++, authentication) && (cov_1k2pmu8boi.b[1][1]++, authentication.config)) {
    cov_1k2pmu8boi.b[0][0]++;
    cov_1k2pmu8boi.s[3]++;
    _authenticationConfig = authentication.config;
    cov_1k2pmu8boi.s[4]++;
    _repositoryConfig.defaultOwner = authentication.user.username;
  } else {
    cov_1k2pmu8boi.b[0][1]++;
  }

  cov_1k2pmu8boi.s[5]++;

  if ((cov_1k2pmu8boi.b[3][0]++, !repository) && (cov_1k2pmu8boi.b[3][1]++, blob)) {
    cov_1k2pmu8boi.b[2][0]++;
    cov_1k2pmu8boi.s[6]++;
    onBlob();
  } else {
    cov_1k2pmu8boi.b[2][1]++;
  }

  var drawerMenuComponent = (cov_1k2pmu8boi.s[7]++, _react.default.createElement(_.DrawerMenu, {
    drawerMenu: drawerMenu,
    repository: repository,
    config: _repositoryConfig,
    blob: blob,
    onBlob: onBlob
  }));
  var repositoryMenuComponent = (cov_1k2pmu8boi.s[8]++, _react.default.createElement(_.RepositoryMenu, {
    authentication: authentication,
    repository: repository,
    onRepository: onRepository,
    repositoryConfig: _repositoryConfig
  }));
  var userMenuComponent = (cov_1k2pmu8boi.s[9]++, _react.default.createElement(_.UserMenu, {
    authentication: authentication,
    onAuthentication: onAuthentication,
    authenticationConfig: _authenticationConfig
  }));
  cov_1k2pmu8boi.s[10]++;
  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement(_core.AppBar, {
    position: "static",
    className: classes.appBar
  }, _react.default.createElement(_core.Toolbar, {
    "data-test": "application-bar"
  }, _react.default.createElement("div", {
    className: classes.menuButton
  }, drawerMenuComponent), _react.default.createElement(_core.Typography, {
    variant: "h6",
    color: "inherit",
    className: classes.grow,
    noWrap: true
  }, title), _react.default.createElement(_core.Typography, {
    variant: "subtitle2",
    color: "inherit",
    className: classes.grow,
    noWrap: true
  }, blob ? (cov_1k2pmu8boi.b[4][0]++, blob.filepath) : (cov_1k2pmu8boi.b[4][1]++, '')), _react.default.createElement("div", {
    className: classes.grow
  }), buttons, repositoryMenuComponent, userMenuComponent)));
}

cov_1k2pmu8boi.s[11]++;
ApplicationBarComponent.propTypes = {
  /** The title string to be displayed. */
  title: _propTypes.default.string,

  /** Additional buttons to be displayed. */
  buttons: _propTypes.default.element,

  /** Component to render inside of the drawer menu. */
  drawerMenu: _propTypes.default.element // ...withAuthentication.propTypes,
  // ...withRepository.propTypes,

};
var ApplicationBar = (cov_1k2pmu8boi.s[12]++, (0, _styles.withStyles)(_styles2.default, {
  withTheme: true
})(ApplicationBarComponent));
exports.ApplicationBar = ApplicationBar;